export const EMPHASIS_TAG_NAME = 'blockquote';
